module.exports = __webpack_public_path__ + "media/images/wfc/city-2-ee4a5c92f260c7bc749fe2f7161e62ec.jpg";